import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { getMetaValue } from "../plugins/src/metadata"

export default class extends Controller {

  connect() {
    Sortable.create(this.element, {
      onEnd: this.onEnd.bind(this),
      group: 'shared',
      animation: 150,
      handle: ".sortable-column-handle",
      forceFallback: true,
    });
  }

  onEnd(event) {
    let url = event.item.dataset.columnSortablesPath
    let data = {
      column: {
          slide_id: event.to.dataset.columnSortablesSlideId,
          column_order_position: event.newIndex,
        }
    }

    fetch(url, {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": getMetaValue("csrf-token"),
        },
        body: JSON.stringify(data)
    })
      .then(response => response.json())
      .catch(error => console.error(error));
  }

}
